export var getRTSStatusError = function (id) {
    return "Package ".concat(id, " is currently marked \u201CRTS\u201D and cannot be rescheduled");
};
export var getDeliveredStatusError = function (id) {
    return "Delivered package ".concat(id, " can't be rescheduled. Adjust its status or remove it from the trip, then try again.");
};
//# sourceMappingURL=errorMultipleTripUpdate.js.map